import { render, staticRenderFns } from "./XlsxController.vue?vue&type=template&id=51324365&scoped=true"
import script from "./XlsxController.vue?vue&type=script&lang=js"
export * from "./XlsxController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51324365",
  null
  
)

export default component.exports